/**
 * Responsáel pela camada de rota planejada
 * Created by adalto on 5/13/14.
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.LayerPlannedRoute = (function () {

    function LayerPlannedRoute () {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = 'planned_route';
        this.RESOURCE_LAYER = 'RouteDetail.ToolBar.Layers.PlannedRoute';

        var instanceToDataClass = null;

        this.setInstanceToClassData = function (instance) {
            instanceToDataClass = instance;
        };

        this.afterClickOnCheckBox = function (context) {

            return function () {

                var _element = this;

                context.setLayerStatusOnLocalStorageByTagName(_element.checkBox.checked);

                if (_element.checkBox.checked) {

                    if (instanceToDataClass) {
                        instanceToDataClass.drawPlannedRoute();
                    }

                } else {

                    if (instanceToDataClass) {
                        instanceToDataClass.removePlannedRoute();
                    }
                }

            };

        }(this);

    }

    return LayerPlannedRoute;

})();
